<button class="survey-answer-cancel exit-button-icon" (click)="cancelOnClick()" type="button" mat-icon-button>
	<mat-icon svgIcon="md:close"></mat-icon>
</button>
<div class="survey-title" mat-dialog-title>
	<span translate>survey.answer.dialog.title</span>&ngsp;
	<span  class="survey-bold">{{getSurveyScreenCodeTr(screenCode) | translate}}</span>
</div>
<div class="survey-answer-grid" mat-dialog-content>
	<div class="survey-dialog-title-block">
		<div class="survey-evaluate" translate>survey.evaluate.statement</div>	
	</div>
	<div class="survey-mood">
		<div class="survey-mood-label">
			<span class="survey-mood-disagree" translate> survey.strongly</span>
			<span class="survey-mood-disagree" translate> survey.disagree</span>
			<mat-icon class="survey-mood-disagree" svgIcon="md:bad_mood" color="accent"></mat-icon>
		</div>
		<div class="survey-mood-label">
			<span class="survey-mood-agree" translate> survey.strongly</span>
			<span class="survey-mood-agree" translate> survey.agree</span>
			<mat-icon class="survey-mood-agree" svgIcon="md:mood" color="accent"></mat-icon>
		</div>
	</div>
	<span class="survey-answer-scores" *ngFor="let score of scores" [style.grid-area]="'2 / ' + (score + 1)">
		{{score}}
	</span>
	<div class="survey-answer-statments"> 
		1.&ngsp;
		<span translate>survey.statements</span>&ngsp;
		<span class="survey-bold" translate>survey.ease.find.information</span>
	</div>
	<mat-radio-group class="survey-radio-group" [formControl]="easyToFindScoreControl">
		<mat-radio-button *ngFor="let informationFindabilityScore of scores" [value]="informationFindabilityScore">
		</mat-radio-button>
	</mat-radio-group>
	<div class="survey-answer-statments">
		2.&ngsp;
		<span translate>survey.statements</span>&ngsp;
		<span class="survey-bold" translate>survey.amount.of.time</span>
	</div>
	<mat-radio-group class="survey-radio-group" [formControl]="timeAmountScoreControl">
		<mat-radio-button *ngFor="let timeAmountScore of scores" [value]="timeAmountScore">
		</mat-radio-button>
	</mat-radio-group>
	<div class="survey-answer-statments">
		3.&ngsp;
		<span translate>survey.statements</span>&ngsp;
		<span class="survey-bold" translate>survey.clarity.information</span>
	</div>
	<mat-radio-group class="survey-radio-group" [formControl]="clarityScoreControl">
		<mat-radio-button *ngFor="let informationClarityScore of scores" [value]="informationClarityScore">
		</mat-radio-button>
	</mat-radio-group>
</div>
<div class="survey-answer-button survey-row-right" mat-dialog-actions>
	<button [disabled]="!surveyScoresControl()" type="submit" (click)="surveyAnswer()" cdkFocusInitial mat-raised-button>
		<span class="survey-answer-button-label" translate>order.submit</span>
		<mat-icon [class.survey-send-icon-disabled]="!surveyScoresControl()" svgIcon="send" color="accent"></mat-icon>
	</button>
</div>	
